module.exports = __webpack_public_path__ + "static/shuttlevision-cctv-school-bus-ticket-mobile-hero-ee29b077da03770fe7929fde7e88e9a5.jpg";